import { FieldGeneral } from 'api/endpoints/processFields';
import { WithFormId, WithReleaseOrDraftProcessId } from 'api/types/pathParams';
import { ApiObligationType } from 'constants/form';

import { API_REQ_ACTION_TYPES } from '../actions';
import apiReqSagaCreator from '../apiReqSagaCreator';
import { ApiPaths, HTTP_METHODS } from '../constants';

export const generateMutationPayload = (
  form: FormGeneral
): FormMutationPayload => ({
  description: form.description ?? '',
  fields:
    form.fields?.map((field) => ({
      fieldId: field.id,
      fieldObligationType: field.obligationType,
      multiValues: field.multiValues,
    })) ?? [],
  name: form.name,
  instanceNameFieldId: form.instanceNameField?.id,
  isInitial: form.isInitial,
  isFinal: form.isFinal,
});

export interface FormMutationPayload extends WithHypermedia {
  name: string;
  description: string;
  fields: {
    fieldId: string;
    fieldObligationType: string;
    multiValues?: boolean;
  }[];
  instanceNameFieldId?: string;
  isInitial: boolean;
  isFinal: boolean;
}

export interface FormFieldOpts {
  obligationType: ApiObligationType;
  multiValues?: boolean;
}

export type FieldWithObligationType = FieldGeneral & FormFieldOpts;

export type FormGeneral = BaseEntity &
  WithHypermedia & {
    description?: string;
    fieldsCount?: number;
    fields?: FieldWithObligationType[];
    isInitial: boolean;
    isFinal: boolean;
    instanceNameField?: FieldGeneral;
  };

export type UpdateByIdResult = FormGeneral;
export type CreateResult = FormGeneral;

export type GetAllFormsResult = DataWithTotal<FormGeneral>;
export type GetFormByIdParams = WithReleaseOrDraftProcessId & WithFormId;
export type GetFormByIdResult = FormGeneral;

const ProcessForm = {
  getFormById: apiReqSagaCreator<GetFormByIdParams, GetFormByIdResult>(
    API_REQ_ACTION_TYPES.PROCESSES.GET_FORM_BY_ID,
    (params) => ({
      method: HTTP_METHODS.GET,
      url: ApiPaths.processes.byId.processForms.byId._(params),
    })
  ),
};

export default ProcessForm;
